import { useAuthStore } from '@lib/store';
import { LocalStorageUtils } from './localStorageUtils';
import { AuthApi, LoginResponse } from '@shared/api';
import { RoutePaths } from './routeUtils';

export class AuthUtils {
  static getToken = () => useAuthStore.getState().data?.token;

  static getUserId = () => this.parseToken()?.sub;

  static parseToken = () => {
    const token = this.getToken();
    if (!token) return null;
    return JSON.parse(atob(token.split('.')[1]));
  };

  static login = (data: LoginResponse) => {
    useAuthStore.getState().setAuth(data);
    LocalStorageUtils.setAuth(data);
    window.location.href = RoutePaths.dashboard.onNavigate();
  };

  static logout = (options: { byApi?: boolean } = {}) => {
    !options.byApi && AuthApi.logout();
    LocalStorageUtils.removeAuth();
    useAuthStore.getState().clear();
    window.location.href = RoutePaths.login.onNavigate();
  };
}
